import script from "./TasksView.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksView.vue?vue&type=script&setup=true&lang=js"

import "./TasksView.vue?vue&type=style&index=0&id=58209b8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58209b8a"]])

export default __exports__